import {Component} from '@angular/core';

@Component({
  selector: 'tgrid-page-header',
  standalone: true,
  imports: [],
  template: `
    <h4>
      The <b>TASTI-GRID tool</b> helps state and tribal officials administering the <b>Grid Resilience State and Tribal
      Formula Grant program</b> (BIL Section 40101d) make decisions about <b>where to invest resources</b>.
<!--      <a class="clickable" routerLink="/about">Learn more</a>-->
    </h4>

  `,
  styles: `
    :host {
      display: block;
      font-family: "Mulish", sans-serif;
    }

    a {
      color: var(--primary-link-color, #04682A);
      font-size:  var(--body-xl-font-size, 24px);
      font-weight:  var(--body-bold-weight, 700);
      line-height: 150%;
      text-decoration-line: underline;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-position: from-font;
    }

    h4  {
      font-size: var(--body-xl-font-size, 24px);
      font-style: normal;
      font-weight: var(--body-weight, 400);
      line-height: 150%;

      & > b {
        font-weight: var(--body-bold-weight, 700);
      }
    }
  `,
})
export class PageHeaderComponent {

}
